<template>
  <div class="container">
    <h2 class="report-title">Foundational Astrology Report</h2>
    <h3 class="report-title">Your Core Personality and Life Patterns</h3>
    <p style="text-align: justify;">This report offers a <b>foundational analysis of your birth chart</b>, providing an insightful understanding of your core personality by exploring three key elements: Your <b>Ascendant</b>, <b>Planetary Placements</b>, and <b>House Lord Placements</b>.</p>    

    <h3 class="report-title">What This Report Covers</h3>    
    <ul>
      <li style="padding: 5px;"><strong>Ascendant (Lagna): </strong> Your outward personality, approach to life, and physical traits.</li>
      <li style="padding: 5px;"><strong>Planetary Placements :</strong> Impact of each planet in your chart and how they shape your life patterns.</li>
      <li style="padding: 5px;"><strong>House Lord Placements :</strong> Influence of each house lord when placed in a different house in your birth chart.</li>
    </ul>

    <h3 class="report-title">How This Report Helps You</h3>
    <p style="text-align: justify;">
      This report gives you clarity on strengths and challenges associated with each planetary placement and how different areas of life are influenced by Astrological houses in your chart.
    </p>

    <h3 class="report-title">Why You Should Get This Report</h3>
    <p style="text-align: justify;">
      A great starting point for beginners seeking an easy-to-understand astrology report. 
      It provides <b>foundational insights into the Natal Chart</b>, making it an excellent first step for deeper astrological exploration. 
      Best of all, it's free - everyone should take advantage of this opportunity!    
    </p>

    <h3 style="color: orangered; margin-top: 30px;"><strong>Cost: FREE</strong></h3>

    <div style="width: 95%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
      <input type="email"
            ref="userEmail"
            id="userEmail"
            name="userEmail"
            v-model="criteria.email"
            placeholder="Your Email Address"
            size="30"
            style="height: 32px; border-radius: 6px; font-size: 14px;" />

      <a @click="sendMessage()" class="cta-button">
          <font-awesome-icon :icon="['fas', 'envelope']" size="lg" />&nbsp;
          Email My Report</a>

      <a @click="activate('chart-interpretations')" class="cta-button">Back</a>
  </div>



  </div>
</template>

<script>
import HTTP from '../http-axios';
import ApiBaseUrl from '../http-api-base-url'
import { queryString, generatePaidNatalChartKey } from '@/util.js'

export default {
  props: {
    criteria: {
      type: Object
    }
  },
  data() {
    return {
      orderDescription: 'Foundational Astrology Report from www.vedicastrochart.com',
    }
  },
  methods: {

		activate(menuItem) {
      console.log('PurchaseFoundational: ' + menuItem)
			this.$emit('activeMenuItem', menuItem);
		},

    downloadFoundationalChartPDF() {
      HTTP().get(ApiBaseUrl() + '/api/pdf/natalchart?' + this.queryString(this.criteria) + '&ct=' + this.getCriteriaToken(this.criteria), {
          responseType: 'blob'
        })
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/pdf'
          })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = new String("VedicAstroChart" + (this.criteria.client ? " - " + this.criteria.client : ""))
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },

    queryString: function (obj) {
        return queryString(obj);
    },
    getCriteriaToken: function() {
        return generatePaidNatalChartKey(this.criteria);
    },
    showSampleNatalChart() {
        window.open(ApiBaseUrl() + '/api/pdf/sample/natalchart', "_blank");
    },  
  }

}

</script>

<style scoped>
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #ffffff;
  color: #333;
}
.container {
  max-width: 800px;
  margin: 120px auto;
  padding-right: 25px;
  padding-left: 25px;
  padding-top: 5px;
  border-radius: 12px;
  background: #EDF6F9; /* Updated background color */
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  border: 0px solid;
  line-height: 1.5;
}
.report-title {
  color: #087F8C;
  text-align: left;  
}
p, ul {
  text-align: left;
}
ul {
  padding-left: 20px;
}
.cta-button {
  display: inline-block;
  padding: 12px 25px;
  background-color: #087F8C;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  margin: 10px 0;
  font-weight: bold;
  text-align: center;
  width: fit-content;
  cursor: pointer;
}
.cta-button:hover {
  background-color: #218838;
}

input[type=text] {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;  
  padding: 12px 12px;
  margin: 2px 0;
  box-sizing: border-box;
  border: 2px solid #087F8C;
  -webkit-transition: 0.5s;
  transition: 0.2s;
  outline: none;
}

input[type=text]:focus {
  border: 2px solid #ACD8AA;
}

input[type=email] {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;  
  padding: 12px 12px;
  margin: 2px 0;
  box-sizing: border-box;
  border: 2px solid #087F8C;
  -webkit-transition: 0.5s;
  transition: 0.2s;
  outline: none;
}

input[type=email]:focus {
  border: 2px solid #ACD8AA;
}

@media (max-width: 768px) {
  .container {
    max-width: 100%;
    padding: 15px;
    margin: 15px;
    border-radius: 6px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);    
  }
  .cta-button {
    width: fit-content;
    padding: 12px 20px;
    margin: 20px 0;
  }
}
</style>
